<template>
  <div>
    <p>
      {{ $t("classes.create_class_flow.available_licenses") }}
    </p>
    <div class="available-license">
      <div v-if="!showRadio" class="wrap-license">
        <p v-for="label in headAvaiMemberships" :key="label.id">{{ label.plan_label }}</p>
      </div>
      <div class="wrap-radio" v-else>
        <el-radio
          size="medium"
          class="radio"
          v-model="license"
          v-for="item in headAvaiMemberships"
          :key="item.id"
          :label="item"
        >
          {{ item.plan_label }} {{ calculateRemaining(item) }}
        </el-radio>
      </div>
    </div>
    <div v-if="showRadio && license.id" class="wrap-assign-all">
      <span class="wrap-assign-all__text">Click to assign license to learners</span>
      <div class="wrap-assign-all__wrap-button">
        <el-button @click="handleAssignAll" type="primary">Assign All</el-button>
        <el-button @click="handleClearAll">Clear All</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headAvaiMemberships: {
      type: Array,
    },
    selectedLicense: {
      type: Object,
      default: () => {
      },
    },
    showRadio: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      license: {},
    };
  },
  methods: {
    handleAssignAll() {
      this.$emit("assignAll", this.license);
    },
    handleClearAll() {
      this.$emit("clearAll");
    },
    calculateRemaining(item) {
      if (!this.showRadio) return "";
      if (item.id.toString().includes("_") || item.id.toString().includes("|")) {
        return this.calculateRemainingFromCombine(item);
      }
      if (!this.selectedLicense[item.id]) return "";
      return `(Remaining: ${item.qty - this.selectedLicense[item.id].length})`;
    },
    calculateRemainingFromCombine(item) {
      const idStr = item.id.toString();
      if (idStr.includes("_")) {
        let remain = 0;
        idStr.split("_").forEach(pair => {
          const [id, qty] = pair.split("|");
          if (this.selectedLicense[id]) {
            remain += this.selectedLicense[id].length;
          }
        });
        return remain > 0 ? `(Remaining: ${item.qty - remain})` : "";
      } else if (idStr.includes("|")) {
        const [id, qty] = idStr.split("|");
        return !this.selectedLicense[id] ? "" : `(Remaining: ${item.qty - this.selectedLicense[id].length})`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin-bottom: 32px;
}

::v-deep .el-radio__label {
  font-size: 18px;
}

.el-radio__label {
  color: #000000 !important;
}

.wrap-license {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;

  p {
    padding: 0;
    margin: 0;
    font-weight: 700;
  }
}

.wrap-radio {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-left: 25px;
  margin-top: -10px;
  margin-bottom: 25px;
}

.wrap-assign-all {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;

  &__wrap-button {
    display: inline-block;
  }
}
</style>
